<template>
  <div class="card-body p-1">
    <p class="card-text p-0">
      Daten konnten nicht geladen werden. Probieren Sie es später nochmal.
      <button
        v-on:click="$emit('reload')"
        class="btn btn-outline-primary btn-block"
        type="button"
      >
        <i class="fas fa-sync"></i>
      </button>
    </p>
  </div>
</template>

<script>
export default {
  name: "ContentStaticProviderError"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
